import { render, staticRenderFns } from "./ServiceWorker.vue?vue&type=template&id=68a63f2d&scoped=true"
import script from "./ServiceWorker.vue?vue&type=script&lang=js"
export * from "./ServiceWorker.vue?vue&type=script&lang=js"
import style0 from "./ServiceWorker.vue?vue&type=style&index=0&id=68a63f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a63f2d",
  null
  
)

export default component.exports